import React, { useEffect, useState } from "react";
import { caApi } from "../../../backend_urls/caApi";
import ClientsTable from "./models/manage_clients_model/ClientsTable";
import ViewClientInfo from "./models/manage_clients_model/ViewClientInfo";
import CreateClient from "./models/manage_clients_model/CreateClient";
import LoadingSpinner from "../../../components/loaders/LoadingSpinner";
import ReusableForm from "../../../components/reusable/ReusableForm";
import "../../../css/pages/ca_pages/CAAllClientsManagementPage.css"

const CAAllClientsManagementPage = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Set Drawer state
    const [drawer, setDrawer] = useState({ open: false, loading: false, request: null });

    const [showCreateClientPopup, setShowCreateClientPopup] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [showCreateClientsBusinessPopup, setShowCreateClientsBusinessPopup] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await caApi.getAllClients();
            setData(res.data || res);
        } catch (error) { console.error("Error fetching invoices:", error);
        } finally { setLoading(false); }
    };
    useEffect(() => { fetchData(); }, []);

    const handleViewRequest = async (clientId) => { 
        try {
            setDrawer({ open: true, loading: true, request: null });
            const res = await caApi.retrieveClientDetails(clientId);
            setDrawer({ open: true, loading: false, request: res.data });
        } catch (error) {
            console.error(error);
            setDrawer({ open: false, loading: false, request: null });
        };
    };

    const closeDrawer = () => {
        setDrawer({ open: false, loading: false, request: null });
    };

    const handleClientSaved = async (client) => {
        try {
            setShowCreateClientPopup(false);
            setLoading(true);
            await fetchData();
        } catch (error) { console.error("Error saving client:", error);
        } finally { setLoading(false); }
        // optional toast
        // toast.success("Client created successfully");
    };

    const handleAddBusiness = (client) => {
        setSelectedClient(client);
        setShowCreateClientsBusinessPopup(true);
    };
    const handleClientBusinessSaved = async (business) => {
        try {
            setShowCreateClientsBusinessPopup(false);
            setLoading(true);
            await caApi.createClientBusiness(selectedClient?.id, business);
        } catch (error) { console.error("Error saving client business:", error);
        } finally { setLoading(false); }
        // optional toast
        // toast.success("Client business created successfully");
    }

    const handleFileUpload = async ({ businessId, file, uploadType }) => {
        setLoading(true);
        try {
            if (uploadType === "invoice") {
                await caApi.createClientInvoice(businessId, file);
            } else if (uploadType === "excel") {
                await caApi.uploadClientExcel(businessId, file);
            }
        } catch (error) { console.error("Error uploading file:", error);
        } finally { setLoading(false); }
    };

    return ( loading ? <LoadingSpinner /> : <>
        <div className="ca-clients-page">
            <div className="ca-clients-header">
                <h1>All Clients</h1>

                <button
                    className="add-client-btn"
                    onClick={() => setShowCreateClientPopup(true)}
                >
                    Add Client
                </button>
            </div>

            <ClientsTable
                clients         = { data }
                onView          = { handleViewRequest }
                onAddBusiness   = { handleAddBusiness }
                onFileUpload    = { handleFileUpload }
            />
        </div>

        {showCreateClientPopup && (
            <CreateClient
                onClose = { () => setShowCreateClientPopup(false) }
                onSave  = { handleClientSaved }
            />
        )}

        <ViewClientInfo
            isOpen  = { drawer.open }
            loading = { drawer.loading }
            request = { drawer.request }
            onClose = { closeDrawer }
        />

        <ReusableForm
            isOpen  = { showCreateClientsBusinessPopup }
            title   = {`Create Business for ${selectedClient?.user_full_name || ""}`}
            onClose = { () => {
                setShowCreateClientsBusinessPopup(false);
                setSelectedClient(null);
            }}
            onSubmit      = { handleClientBusinessSaved }
            initialValues = { { client_name: selectedClient?.user_full_name } }
            fields        = {[
                { name: "client_name", label: "Client Name", readOnly: true },
                { name: "business_name", label: "Business Name", required: true },
                { name: "business_address", label: "Business Address", required: true },
                { name: "gstin", label: "GSTIN", required: true },
                { name: "state_code", label: "State Code", required: true },
            ]}
        />
    </>);
};

export default CAAllClientsManagementPage;
